'use client';
import React from 'react';
import ContentWrapper from '@/components/common/ContentWrapper';
import ResponsiveSpacing from '@/components/common/ResponsiveSpacing';

interface ProductLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const ProductLayout: React.FC<ProductLayoutProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <ResponsiveSpacing data-component-id="src/components/sections/ProductLayout.tsx:16:4" data-component-path="src/components/sections/ProductLayout.tsx" data-component-line="16" data-component-file="ProductLayout.tsx" data-component-name="ResponsiveSpacing" data-component-content="%7B%22elementName%22%3A%22ResponsiveSpacing%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" padding="md" className={className}>
        <div data-component-id="src/components/sections/ProductLayout.tsx:17:8" data-component-path="src/components/sections/ProductLayout.tsx" data-component-line="17" data-component-file="ProductLayout.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20lg%3Aflex-row%20gap-9%22%7D" className="flex flex-col lg:flex-row gap-9">
          {children}
        </div>
    </ResponsiveSpacing>
  );
};

export default ProductLayout; 